import 'bootstrap';
import _ from 'lodash';

let executedComponents = [];
let componentSources   = [];

let initComponents = async () => {
	/**
	 * Bootstrap the components
	 */
	const components = _.uniq(
		[...document.querySelectorAll( '[data-component]' )].map( ( el ) => el.dataset.component )
	).filter( ( component ) => !executedComponents.includes( component ) );
	
	await Promise.all(components.map(async (componentName) => {
		try {
			let loadingStart = performance.now()
			let component = componentSources[componentName];
			
			if(!component) {
				component = await import(
					/* WebpackMode: "lazy" */
					/* webpackPrefetch: true */
					/* webpackPreload: true */
					`../components/${componentName}/${componentName}.js`
				);
			}

			await component.default();
			executedComponents.push(componentName);

			componentSources[componentName] = component;
			
			let loadingEnd = performance.now();
			if (window.env !== 'production') console.debug(`Component ${componentName} loaded in ${loadingEnd - loadingStart} milliseconds.`);

			window.dispatchEvent( new CustomEvent( 'components:loaded:' + componentName ) );
		} catch (e) {
			console.error(`Component ${componentName} failed to load.`);
			console.error(e);
		}
	}));
	
	window.dispatchEvent( new CustomEvent( 'components:loaded' ) );
}

document.addEventListener('afterBlitzInject', (event) => {
	// Reload components that were injected to ensure the JS works
	let injectedComponents = _.uniq([...document.querySelectorAll( '.blitz-inject [data-component]' )].map( ( el ) => el.dataset.component ));
	executedComponents = executedComponents.filter( ( component ) => !injectedComponents.includes( component ) );
	if (window.env !== 'production') console.debug(`Reloading components: ${injectedComponents.join(', ')}`);

	initComponents();
});

document.addEventListener( 'DOMContentLoaded', async () => {
	initComponents();
} );
